// Translate cart drawer to Hebrew
(function() {
  const translations = {
    'Your cart': 'עגלת הקניות שלך',
    'Product': 'מוצר',
    'PRODUCT': 'מוצר',
    'Total': 'סה״כ',
    'TOTAL': 'סה״כ',
    'Estimated total': 'סה״כ משוער',
    'Check out': 'תשלום',
    'Checkout': 'תשלום',
    'Taxes, discounts and shipping calculated at checkout.': 'מסים, הנחות ומשלוח יחושבו בקופה.',
    'Taxes included. Discounts and shipping calculated at checkout.': 'מסים כלולים. הנחות ומשלוח יחושבו בקופה.',
    'Your cart is empty': 'עגלת הקניות שלך ריקה',
    'Order special instructions': 'הוראות מיוחדות להזמנה'
  };

  function translateElement(element) {
    if (!element) return;

    const text = element.textContent.trim();
    if (translations[text]) {
      element.textContent = translations[text];
    }
  }

  function translateCartDrawer() {
    // Translate cart title
    const cartTitle = document.querySelector('.drawer__heading');
    translateElement(cartTitle);

    // Translate column headers
    const headers = document.querySelectorAll('.cart-items th');
    headers.forEach(translateElement);

    // Translate estimated total
    const estimatedTotal = document.querySelector('.totals__total');
    translateElement(estimatedTotal);

    // Translate checkout button
    const checkoutBtn = document.querySelector('.cart__checkout-button');
    translateElement(checkoutBtn);

    // Translate tax note
    const taxNote = document.querySelector('.tax-note');
    translateElement(taxNote);

    // Translate empty cart message
    const emptyText = document.querySelector('.cart__empty-text');
    translateElement(emptyText);

    // Translate order notes
    const noteTitle = document.querySelector('#Details-CartDrawer .summary__title');
    if (noteTitle) {
      const text = noteTitle.textContent.trim();
      if (text.includes('Order special instructions')) {
        noteTitle.childNodes[0].textContent = 'הוראות מיוחדות להזמנה';
      }
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateCartDrawer);
  } else {
    translateCartDrawer();
  }

  // Watch for cart drawer updates
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length || mutation.type === 'characterData') {
        translateCartDrawer();
      }
    });
  });

  // Start observing when drawer exists
  function startObserving() {
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } else {
      // Try again after a short delay
      setTimeout(startObserving, 100);
    }
  }

  startObserving();
})();
